var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfdPlatformAdaptive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1506_25628",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5009 3.05004C13.7158 1.44165 10.2842 1.44165 7.4991 3.05004L6.4991 3.62754C3.715 5.23537 2 8.20623 2 11.4213V12.5804C2 15.7954 3.715 18.7663 6.4991 20.3741L7.4991 20.9516C10.2842 22.56 13.7158 22.56 16.5009 20.9516L17.5009 20.3741C20.285 18.7663 22 15.7954 22 12.5804V11.4213C22 8.20623 20.285 5.23537 17.5009 3.62754L16.5009 3.05004ZM12.0001 16.6739C14.7344 15.7957 16.4498 11.7909 16.6555 9.714C15.8071 8.16879 13.4514 7.32774 12.0001 7.32776C10.5487 7.32774 8.19299 8.16879 7.34465 9.714C7.55035 11.7909 9.26568 15.7957 12.0001 16.6739Z",
    fill: "url(#paint0_linear_1506_25628)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1506_25628)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.21875,
    y: 0.6875,
    width: 21.9766,
    height: 22.312,
    fill: "url(#paint1_linear_1506_25628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3141 10.6261C19.8494 17.7692 14.4309 17.6684 11.982 16.6675L7.69985 8.96673L4.46094 10.6261V18.6068L9.85743 22.9281L25.1579 25.4813C25.2369 17.5533 24.7787 3.48295 22.3141 10.6261Z",
    fill: "url(#paint2_linear_1506_25628)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6524 9.71254C15.1256 2.77808 7.81588 2.62378 4.2396 3.3633C0.788029 3.53851 -0.60308 8.63029 -0.867188 11.1543L0.783484 20.3899L7.36823 20.8897C4.19077 15.9778 6.02053 11.312 7.34447 9.71253L16.6524 9.71254Z",
    fill: "url(#paint3_linear_1506_25628)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1506_25628",
    x1: 12,
    y1: 1.84375,
    x2: 12,
    y2: 22.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7551FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7872F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1506_25628",
    x1: 17.2068,
    y1: 3.37005,
    x2: 11.6745,
    y2: 16.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1506_25628",
    x1: 17.5979,
    y1: 21.3487,
    x2: 5.77539,
    y2: 16.4883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1506_25628",
    x1: 0.0222901,
    y1: 18.977,
    x2: 15.2322,
    y2: 6.73329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfdPlatformAdaptive);
export default __webpack_public_path__ + "static/media/NfdPlatformAdaptive.514bc479ea7f64693f13332f666eb0bf.svg";
export { ForwardRef as ReactComponent };